import React from "react";
import Modal from "react-modal";

export const ConfirmDestroy = ({ no, yes, open, text }) => {
  return (
    <Modal
      className="max-w-lg w-full bg-white p-8 border-2 border-gray-200 rounded-lg fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 shadow-lg z-20"
      isOpen={open}
      ariaHideApp={false}
      style={{ overlay: { zIndex: 1000 } }}
    >
      <div>
        <div className="text-center text-gray-800 font-bold text-2xl">
          Atenção
        </div>

        <p className="text-md text-gray-500 text-center mt-2">{text}</p>

        <div className="flex flex-col gap-2 mt-8">
          <button
            onClick={() => {
              yes();
            }}
            className="rounded bg-primary-500 text-white text-center p-2 hover:bg-primary-700 font-bold w-full transition-colors"
          >
            Confirmar
          </button>
          <button
            onClick={() => {
              no();
            }}
            className="rounded border-2 border-red-500 text-red-500 text-center p-2 hover:bg-gray-200 font-bold w-full transition-colors"
          >
            Cancelar
          </button>
        </div>
      </div>
    </Modal>
  );
};
